import { usePlayerActions } from "@utils/player/core/usePlayer";
import List from "@components/Collection/List";
import { getPlaylistSubtitle } from "@components/Collection/playlist/helpers";
import usePlaylistScreenData from "@components/Collection/playlist/usePlaylistScreenData";
import { useMe } from "@hooks/trpc/useMe";
import { useTodaysTopHitsSuspense } from "@hooks/trpc/useTodaysTopHits";
import { handleArtistNavigation } from "@utils/index";
import { getCountryCode } from "@utils/region";
import { ValidTerritoryCode } from "@libs/utils";

import { useCallback } from "react";

type PlaylistProps = {
  id: string;
  songId?: string;
};

const TodaysTopHitsPlaylist = ({ id, songId }: PlaylistProps) => {
  const playerActions = usePlayerActions();

  const me = useMe();
  const {
    query: { data: user },
  } = me;

  const { data: todaysTopHits, isFetching } = useTodaysTopHitsSuspense();

  const { songs, isOwner, images } = usePlaylistScreenData(
    TodaysTopHitsPlaylist.name,
    todaysTopHits,
    songId,
  );
  const playFromCollection = playerActions.playFromCollection;

  const countryCode =
    user?.plan?.countryId ??
    user?.countryCode ??
    (getCountryCode() as ValidTerritoryCode);

  const handlePressList = () => {
    return handleArtistNavigation({
      params: { isPlaylist: true, numberOfArtists: 0 },
    });
  };

  const handleSelectSong = useCallback(
    (songId: string) => {
      playFromCollection({
        songId,
        collectionType: "playlist",
        collectionId: id,
        collectionName: todaysTopHits.title,
        songs,
      });
    },
    [playFromCollection, id, todaysTopHits.title, songs],
  );

  const subtitle = getPlaylistSubtitle(
    user?.name,
    countryCode,
    todaysTopHits.user.name,
    todaysTopHits.id,
  );

  const hasPrivateSong = todaysTopHits.hasPrivateSong;

  return (
    <List
      type="playlist"
      id={id}
      isFetching={isFetching}
      image={images}
      title={todaysTopHits?.title}
      subtitle={subtitle}
      onPress={handlePressList}
      isOwner={isOwner}
      isPublic={todaysTopHits?.visibility === "public"}
      songs={songs || []}
      onSelectSong={handleSelectSong}
      hasPrivateSong={hasPrivateSong}
    />
  );
};

export default TodaysTopHitsPlaylist;
